<template>

  <vue-nestable v-model="listData"
                :hooks="hooks"
                :maxDepth="allowDrag ? 20 : 0"
                :threshold="30"
                keyProp="identifier"
                @change="moveNode">

    <div class="item"
         slot-scope="{ item }">
      <!-- Handler -->
      <vue-nestable-handle v-if="allowDrag"
                           :item="item">
        <i class="mdi mdi-drag"></i>
      </vue-nestable-handle>

      <!-- Content -->
      <LocaleTableItem :node="item"
                       @deleted="removeNode"
                       @edit="(e) => $emit('edit', e)"
                       @pushChild="pushChild"
                       @reloadDeviceCount="$emit('reloadDeviceCount')"
                       @mouseover="emitSetLevel"
                       @mouseleave="emitUnsetLevel">
      </LocaleTableItem>

      <div slot="placeholder"></div>
    </div>

  </vue-nestable>

</template>

<script>
    import { VueNestable, VueNestableHandle } from 'vue-nestable'

    import LocaleTableItem from '@views/locals/components/LocaleTableItem'
    import EventBus from '@packages/event-bus'

    export default {
        props: {
            list: {
                type: Array
            },
            node: {
                type: Object
            },
            allowDrag: {
                type: Boolean,
                default: true
            }
        },

        components: {
            LocaleTableItem,
            VueNestable,
            VueNestableHandle
        },

        data() {
            return {
                moveData : {
                    isMoving: false,
                    pathFrom: undefined,
                    dragItem: undefined,
                },
                listData: this.list.map((item) => {
                    return {
                        ...item,
                        identifier: `${item.tipo}-${item.id}`,
                        children: []
                    }
                }),
                hooks: {
                    beforeMove: this.checkMoveHandler,
                },
            }
        },

        watch: {
            list: function (val) {
                this.listData = val.map((item) => {
                    return {
                        ...item,
                        identifier: `${item.tipo}-${item.id}`,
                        children: []
                    }
                })
            },
        },

        methods: {            
            emitSetLevel(level) {
                this.$emit('setLevel', level);
            },
            emitUnsetLevel(level) {
                this.$emit('unsetLevel', level);
            },
            getDragParent({ pathTo }) {
                let dragParent = this.listData[pathTo[0]];

                for (let index = 1; index < pathTo.length -1; index++) {
                    dragParent = dragParent.children[pathTo[index]];
                }

                return dragParent;
            },
            checkMoveHandler({ pathFrom,  dragItem }) {
                if(!this.moveData.isMoving) {
                    this.moveData.isMoving = true;
                    this.moveData.pathFrom = pathFrom;
                    this.moveData.dragItem = dragItem;
                }

                return true
            },
            realocateNode() {
                //remover do lugar novo
                this.removeNode({
                    id: this.moveData.dragItem.id,
                    type: this.moveData.dragItem.tipo
                });

                //recolocar no lugar antigo
                if(this.moveData.pathFrom.length > 1) {
                    const oldDragParent = this.getDragParent({
                        pathTo: this.moveData.pathFrom
                    });
        
                    if(oldDragParent) {
                        oldDragParent.children.push(this.moveData.dragItem);
                    }
                } else {
                    this.listData.push(this.moveData.dragItem);
                }
              

                //resetar flag de estar movendo para liberar a logica
                this.moveData = {
                    isMoving: false,
                    pathFrom: undefined,
                    dragItem: undefined,
                };
            },
            async isMovable({  dragItem,  dragParent}) {
                if(dragParent) {
                    //Se NAO ESTIVER sendo mudado para a raiz:
                    if(dragItem.tipo === 'LOCAL') {
                        // Se for local, só pode ir pra outro grupo de local
                        const isDragabble = dragParent.tipo === 'GRUPO_LOCAL';

                        if(!isDragabble){
                            return false;
                        }
                    } else if(dragItem.tipo === 'GRUPO_LOCAL') {
                        // Se for grupo de local, só pode ir para outro grupo de local
                        const isDragabble = dragParent.tipo === 'GRUPO_LOCAL';

                        if(!isDragabble){
                            return false
                        }
                    } else if(dragItem.tipo === 'APARELHO') {
                        //Se for aparelho, pode mudar para um gropo de ponto de acesso, desde que o grupo tenha o mesmo localId que o aparelho
                        const isDragabble = dragParent.tipo === 'GRUPO_PONTO_ACESSO' || dragParent.tipo === 'LOCAL';

                        if(!isDragabble) {
                            return false
                        } else {
                            //pesquisar ele e aparelho para checar se mesmo localId
                            const device = await this.$api.devices.get({
                                id: dragItem.id
                            })

                            const parent = dragParent.tipo === 'GRUPO_PONTO_ACESSO' ? 
                                            await this.$api.accessPointGroup.get({
                                                id: dragParent.id
                                            }) :
                                            await this.$api.locals.get(dragParent.id)
                            if(dragParent.tipo === 'GRUPO_PONTO_ACESSO') {
                                return device.localId !== parent.localId ? false : true
                            } else {
                                return device.localId !== parent.id ? false : true
                            }                
                           
                        }
                    } else if(dragItem.tipo === 'GRUPO_PONTO_ACESSO') {
                        // Se for grupo de ponto de acesso pode outro grupo de ponto de acesso ou para outro local
                        const isDragabble = dragParent.tipo === 'GRUPO_PONTO_ACESSO';


                        //precisa checar se outro grupo de ponto de acesso é do mesmo local?

                        if(!isDragabble) {
                            return false;
                        } else {
                            const accessPointGroup = await this.$api.accessPointGroup.get({
                                id: dragItem.id
                            })

                            const parentAccessPointGroup = await this.$api.accessPointGroup.get({
                                id: dragParent.id
                            })

                            if(parentAccessPointGroup.localId !== accessPointGroup.localId) {
                                return false
                            }
                        }
                    }
                } else {
                    //Se ESTIVER sendo mandado para a raiz
                    if(dragItem.tipo === 'APARELHO' || dragItem.tipo === 'GRUPO_PONTO_ACESSO') {
                        return false
                    }
                }


                return true
            },
            async moveNode( value, options ) {
                if(options.pathTo) {
                    const dragParent = options.pathTo.length > 1 ? this.getDragParent({ pathTo: options.pathTo }) : undefined;
                    const isMovable = await this.isMovable({
                        dragItem: this.moveData.dragItem,
                        dragParent: dragParent
                    })
                    if(isMovable) {
                        const alterPositionParam = {
                            id: this.moveData.dragItem.id,
                            dest: dragParent ? dragParent.tipo === 'LOCAL' ? -1 : dragParent.id : 0
                        }

                        try {
                            if(this.moveData.dragItem.tipo === 'LOCAL') {
                                await this.$api.locals.alterPosition(alterPositionParam);
                            } else if(this.moveData.dragItem.tipo === 'GRUPO_LOCAL') {
                                await this.$api.localeGroup.alterPosition(alterPositionParam);
                            } else if(this.moveData.dragItem.tipo === 'APARELHO') {
                                await this.$api.devices.alterPosition(alterPositionParam);
                            } else if(this.moveData.dragItem.tipo === 'GRUPO_PONTO_ACESSO') {
                                if(dragParent && dragParent.tipo === 'LOCAL' && dragParent.id === this.moveData.dragItem.grupoAparelhoLocalId) {
                                    alterPositionParam.dest = 0;
                                }
                                await this.$api.accessPointGroup.alterPosition(alterPositionParam);
                            }

                            if(dragParent) dragParent.hasChildren = true                           

                            EventBus.$emit('show-message', {
                                type: 'SUCCESS',
                                message: 'Item movido com sucesso!',
                                timeout: 2000
                            });

                            if(dragParent) {
                                // this.removeNode({
                                //     id:this.moveData.dragItem.id,
                                //     type: this.moveData.dragItem.tipo
                                // });
                            
                                EventBus.$emit('OPEN_NODE',  {
                                    id: dragParent.id,
                                    type: dragParent.tipo,
                                });
                            }

                            this.moveData = {
                                isMoving: false,
                                pathFrom: undefined,
                                dragItem: undefined,
                            };
                            
                        } catch (error) {
                            this.realocateNode();
                            console.log(error)
                        }
                    } else {
                        EventBus.$emit('show-message', {
                            type: 'ERROR',
                            message: 'O item não pode ser movido para esta posição!',
                            timeout: 2000
                        });
                        this.realocateNode();
                    }
                }
            },
            removeNode({ id, type }) {
                if(type !== 'GRUPO_LOCAL') {
                    const path = this.getPathByIdentifier(`${type}-${id}`, this.listData);
                  
                
                    if(path.length > 1) {
                        const nodeParent = this.getDragParent({ pathTo: path });
    
                        const index = nodeParent.children.findIndex((node) => {
                            return node.id === id && node.tipo === type
                        })
    
                       
                  
                        if(index > -1) {
                            return nodeParent.children.splice(index, 1);
                        }
                    
                    } else {
                        const index = this.listData.findIndex((node) => {
                            return node.id === id && node.tipo === type
                        });
    
                        if(index > -1) {
                            return this.listData.splice(index, 1);
                        }
                    }
                    this.$emit('reloadDeviceCount')
                } else {
                    this.$emit('reload')
                }
            },
            getPathByIdentifier(id, items = this.listData) {
                let path = []

                items.every((item, i) => {
                    if (item['identifier'] === id) {
                        path.push(i)
                    } else if (item.children) {
                        const childrenPath = this.getPathByIdentifier(id, item.children)

                        if (childrenPath.length) {
                            path = path.concat(i).concat(childrenPath)
                        }
                    }

                    return path.length === 0
                })

                return path
            },
            pushChild({ id, type, newNode }) {
                const path = this.getPathByIdentifier(`${type}-${id}`, this.listData);

                let item = this.listData[path[0]];

                for (let index = 1; index < path.length; index++) {
                    item = item.children[path[index]];
                }

                item.children.push(newNode);                
            }    
            
        },
    }
</script>

<style scoped lang="scss">
.item {
  display: flex;

  .nestable-handle {
    display: flex;
    align-items: center;
    font-size: 24px;
  }

  .locale-table-item {
    flex: 1;
  }
}
</style>
